export default __webpack_public_path__ + "static/media/quiet.51ecf45a.png";